import React, { SVGProps } from 'react';

const UnlockOutline = (props: SVGProps<SVGSVGElement>): JSX.Element => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="icon icon--unlock"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.66675 0.666687C5.8258 0.666687 4.33341 2.15907 4.33341 4.00002V4.25002H5.66675V4.00002C5.66675 2.89545 6.56218 2.00002 7.66675 2.00002H8.33342C9.43798 2.00002 10.3334 2.89545 10.3334 4.00002V5.33335H6.00008C4.15913 5.33335 2.66675 6.82574 2.66675 8.66669V12C2.66675 13.841 4.15913 15.3334 6.00008 15.3334H10.0001C11.841 15.3334 13.3334 13.841 13.3334 12V8.66669C13.3334 7.43288 12.6631 6.35564 11.6667 5.77929V4.00002C11.6667 2.15907 10.1744 0.666687 8.33342 0.666687H7.66675ZM12.0001 8.66669C12.0001 7.56212 11.1047 6.66669 10.0001 6.66669H6.00008C4.89551 6.66669 4.00008 7.56212 4.00008 8.66669V12C4.00008 13.1046 4.89551 14 6.00008 14H10.0001C11.1047 14 12.0001 13.1046 12.0001 12V8.66669Z"
        fill="currentColor"
      />
    </svg>
  );
};

UnlockOutline.displayName = 'UnlockOutline';

export default UnlockOutline;
